import React from 'react'
import {
    Box,
    Link,
    Typography,
} from '@mui/material';
import { useTranslation, Trans  } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export function Footer() {
    const { i18n } = useTranslation();

    const currentYear = new Date().getFullYear();

    return (
        <Box>
            <Box component="footer" sx={{ textAlign: 'center', p: 1 }}>
                <Typography variant="body2" color="text.secondary">
                    <Trans
                        i18nKey="companyDisclaimer"
                        values={{ year: currentYear }}
                        components={[
                            <NavLink target="_blank" rel="noopener noreferrer" to={'https://www.prinnovainc.com/terms?lang=' + i18n.language} style={{ textDecoration: 'none', color: '#4B7359'}}/>,
                            <NavLink target="_blank" rel="noopener noreferrer" to={'https://www.prinnovainc.com/privacy?lang=' + i18n.language} style={{ textDecoration: 'none', color: '#4B7359'}}/>
                        ]}    
                    />
                </Typography>
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                p: 1
            }}>
                <Link component={NavLink} target="_blank" rel="noopener noreferrer" to={'https://www.prinnovainc.com?lang=' + i18n.language} underline="none">
                    <img src='/images/prinnova_logo.png' alt="Logo" style={{ maxWidth: '100px', height: 'auto' }} />
                </Link>
            </Box>
        </Box>
    );
}
